export default __webpack_public_path__ + "static/iconfont-a9f537851db56202082c43d836ed8c08.ttf";